import { erpAxios } from '..';

const insertSegmentation = async (data) => {
  const res = await erpAxios.post(`/segmentation/add`, data);
  return res;
};

export default insertSegmentation;
